export default "__VITE_ASSET__bQzOm664__"